import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  BUS_ASSIGNMENT_SCHEDULE_PATH,
  BUS_PATH,
  BUS_UNIT_PATH,
  NEW_BUS_ASSIGNMENT_SCHEDULE_PATH,
  NEW_BUS_PATH,
} from '../../../config/paths';
import BusHome from './BusHome';
import RegisteredBusses from './registered-bus/RegisteredBusses';
import RegisteredBus from './registered-bus/RegisteredBus';
import NewRegisteredBus from './registered-bus/NewRegisteredBus';
import EditRegisteredBus from './registered-bus/EditRegisteredBus';
import BusAssignmentSchedules from './bus-assignment-schedule/BusAssignmentSchedules';
import BusAssignmentSchedule from './bus-assignment-schedule/BusAssignmentSchedule';
import NewBusAssignmentSchedule from './bus-assignment-schedule/NewBusAssignmentSchedule';
import EditBusAssignmentSchedule from './bus-assignment-schedule/EditBusAssignmentSchedule';

const BusUnit = () => (
  <Switch>
    <Route exact path={BUS_UNIT_PATH} component={BusHome} />
    <Route exact path={BUS_PATH} component={RegisteredBusses} />
    <Route exact path={NEW_BUS_PATH} component={NewRegisteredBus} />
    <Route exact path={`${BUS_PATH}/:id`} component={RegisteredBus} />
    <Route exact path={`${BUS_PATH}/:id/edit`} component={EditRegisteredBus} />
    <Route
      exact
      path={BUS_ASSIGNMENT_SCHEDULE_PATH}
      component={BusAssignmentSchedules}
    />
    <Route
      exact
      path={NEW_BUS_ASSIGNMENT_SCHEDULE_PATH}
      component={NewBusAssignmentSchedule}
    />
    <Route
      exact
      path={`${BUS_ASSIGNMENT_SCHEDULE_PATH}/:id`}
      component={BusAssignmentSchedule}
    />
    <Route
      exact
      path={`${BUS_ASSIGNMENT_SCHEDULE_PATH}/:id/edit`}
      component={EditBusAssignmentSchedule}
    />
  </Switch>
);

export default BusUnit;
